export const invoiceList = {
  head: {
    title: "Facturación",
    subtitle: "Facturas emitidas a tus huéspedes",
  },
  stats: {
    filterAria: "Filtrar facturas por estado",
    total: "Total",
    draft: "Borradores",
    sent: "Emitidas",
    processing: "Procesando",
    error: "Con error",
    pending: "Pendientes",
    voided: "Anuladas",
  },
  toolbar: {
    searchLabel: "Buscar facturas",
    searchPlaceholder: "N.º de factura, cliente, email, NIF/CIF o reserva…",
    clearSearch: "Limpiar búsqueda",
    propertyLabel: "Alojamiento",
    allProperties: "Todos los alojamientos",
    typeToSearchProperties: "Escribe para buscar alojamientos.",
    noProperties: "No encontramos alojamientos.",
    statusLabel: "Estado",
    emisorLabel: "Emisor",
    allEmisores: "Todos los emisores",
    servicesTitle: "Catálogo de cargos y servicios reutilizables",
    services: "Cargos y servicios",
    createInvoice: "Crear factura",
  },
  exportZip: {
    button: "ZIP",
    title: "Una factura por fichero, cada una con su fecha y su código de reserva, todas dentro de un ZIP",
    generating: "Generando…",
    zipping: "Comprimiendo…",
    noPdfInPeriod: "En el periodo no hay facturas emitidas con PDF.",
    noPdfInPage: "En esta página no hay facturas emitidas con PDF.",
    tooMany: "La selección tiene {total} facturas y el ZIP admite {limit}. Acota el periodo o los filtros.",
    noneDownloaded: "No se ha podido descargar ninguna factura de Invopop. Inténtalo de nuevo en unos minutos.",
    failed: "No se han podido descargar de Invopop {n} factura(s): {codes}.",
    withoutPdf: "{n} factura(s) aún no tienen PDF en Invopop y no van en el ZIP: {codes}.",
    restIncluded: "El resto sí están en el ZIP.",
    error: "No se ha podido generar el ZIP de las facturas.",
  },
  linkedClient: {
    prefix: "Facturas vinculadas a",
    fallbackName: "este cliente fiscal",
    clear: "Quitar filtro de cliente",
  },
  table: {
    numberHeader: "N.º FACTURA",
    customerHeader: "CLIENTE",
    propertyHeader: "ALOJAMIENTO",
    totalHeader: "TOTAL",
    statusHeader: "ESTADO",
    dateHeader: "FECHA",
    actionsHeader: "ACCIONES",
    draftReferenceTitle: "Referencia del borrador. El número fiscal se asigna al emitir.",
    openReserva: "Abrir la reserva",
    viewCreditNote: "Ver la factura rectificativa {code}",
    creditNote: "Factura rectificativa",
    viewError: "Ver error",
    voids: "Anula",
    correctionOf: "Rectif. de",
    correctedBy: "Rectificada por:",
  },
  sortFields: {
    number: "número de factura",
    customer: "cliente",
    property: "alojamiento",
    total: "total",
    status: "estado",
    date: "fecha",
  },
  sort: {
    sortBy: "Ordenar por {label}",
    sortedBy: "Ordenado por {label}, {direction}. Cambiar el orden",
    asc: "ascendente",
    desc: "descendente",
  },
  actions: {
    openPdf: "Abrir factura en PDF",
    editDraftTitle: "Editar datos de cliente y conceptos",
    edit: "Editar",
    previewTitle: "Abrir una vista previa sin validez fiscal",
    preview: "Vista previa",
    sendQuote: "Presupuesto",
    sendQuoteTitle: "Enviar el presupuesto por correo al cliente",
    emitTitle: "Revisar y emitir la factura",
    emit: "Emitir",
    syncTitle: "Actualizar el estado de la factura",
    sync: "Actualizar",
    retryTitle: "Reintentar con datos de facturación actualizados",
    retry: "Reintentar",
    moreOptions: "Más opciones",
    moreOptionsAria: "Más opciones de la factura",
    editCustomer: "Editar datos del cliente",
    deleteReset: "Eliminar y resetear solicitud",
    voidReissue: "Anular y reemitir",
  },
  empty: {
    searchTitle: "No encontramos facturas",
    searchText: "No hay resultados que coincidan con la búsqueda y los filtros actuales.",
    clearFilters: "Limpiar filtros",
    title: "Aún no hay facturas",
    text: "Crea un borrador y emítelo cuando los datos fiscales y los cargos estén listos.",
    createFirst: "Crear primera factura",
  },
  errorModal: {
    title: "Error en la factura",
    hintBefore: "Si el error es de tus datos de facturación (NIF, serie…), corrígelos en",
    hintSettingsPath: "Configuración → Facturación",
    hintBetween: "y luego usa",
    hintRetryWord: "Reintentar",
    hintGuest: "Si el error es de los datos del huésped, usa",
    hintEditWord: "Editar datos del cliente",
    close: "Cerrar",
    retryNow: "Reintentar ahora",
  },
  editCustomer: {
    title: "Editar datos del cliente",
    subtitle: "Corrige los datos y reintenta la factura",
    name: "Nombre / Razón social *",
    taxId: "NIF / CIF / Tax ID",
    country: "País (código 2 letras) *",
    email: "Email *",
    address: "Dirección",
    city: "Ciudad",
    zip: "Código postal",
    hint: "Al guardar se reintentará automáticamente el envío de la factura.",
    cancel: "Cancelar",
    saving: "Guardando…",
    save: "Guardar y reintentar",
  },
  deleteConfirm: {
    title: "Eliminar factura",
    body1: "Se eliminará este intento de factura y se",
    bodyStrong: "reseteará la solicitud del huésped",
    body2: ", permitiéndole volver a ingresar sus datos y solicitar la factura de nuevo.",
    irreversible: "Esta acción no se puede deshacer.",
    cancel: "Cancelar",
    deleting: "Eliminando…",
    confirm: "Sí, eliminar",
  },
  create: {
    titleEdit: "Editar borrador",
    titleCreate: "Crear factura",
    subtitleEdit: "Actualiza cliente, contexto y conceptos. No se emite.",
    subtitleCreate: "Borrador — sin número hasta emitir. No requiere reserva.",
    loading: "Cargando borrador…",
    clientLabel: "Cliente *",
    clientHelp: "Selecciona un perfil fiscal guardado o crea uno nuevo.",
    newClient: "Nuevo cliente",
    company: "Empresa",
    individual: "Particular",
    change: "Cambiar",
    clientSearchPlaceholder: "Buscar por nombre, email o documento…",
    incomplete: "Incompleto",
    noClients: "No encontramos clientes.",
    createClient: "Crear cliente",
    contextTitle: "Contexto de la factura",
    optional: "Opcional",
    contextHelp: "Relaciona esta factura para conservar su trazabilidad. Puedes dejar ambos campos vacíos.",
    propertyLabel: "Alojamiento",
    propertyPlaceholder: "Buscar alojamiento…",
    typeToSearchProperties: "Escribe para buscar alojamientos.",
    noProperties: "No encontramos alojamientos.",
    reservationLabel: "Reserva",
    reservationPlaceholder: "Buscar código, huésped, email…",
    noHolder: "Sin titular",
    typeToSearchReservations: "Escribe para buscar reservas.",
    noReservations: "No encontramos reservas.",
    contextNotice: "La reserva determina el alojamiento y añade la estancia si todavía no fue facturada.",
    chargesTitle: "Cargos y servicios",
    chargesHelp: "Selecciona conceptos guardados en tu catálogo.",
    addCharge: "Agregar cargo o servicio",
    colConcept: "Concepto",
    colQty: "Cant.",
    colUnitPrice: "P. unit.",
    colTotal: "Total",
    docTitle: "Así quedará la factura",
    docHint: "Estas son las líneas que llevará el PDF. El alojamiento, los descuentos y los cargos automáticos salen de la reserva: aquí arriba solo se editan los cargos de tu catálogo.",
    due: "Pendiente de cobro",
    assumed: "No hay cobros anotados en esta reserva. El importe se da por cobrado a partir de la forma de pago marcada, y así saldrá también en el PDF.",
    linesEmpty: "Agrega uno o varios conceptos desde tu catálogo.",
    total: "Total",
    cancel: "Cancelar",
    saving: "Guardando…",
    saveChanges: "Guardar cambios",
    saveDraft: "Guardar borrador",
  },
  contextSummary: {
    property: "Alojamiento seleccionado",
    empty: "Añadir alojamiento o reserva",
  },
  emit: {
    title: "Emitir factura",
    subtitle: "Esta acción asignará el número fiscal definitivo.",
    client: "Cliente",
    property: "Alojamiento",
    total: "Total",
    warning: "Después de emitir no podrás editarla directamente; cualquier corrección requerirá un documento rectificativo.",
    cancel: "Cancelar",
    emitting: "Emitiendo…",
    confirm: "Emitir factura",
  },
  editDraft: {
    title: "Editar borrador",
    subtitle: "Modifica los datos del cliente y los conceptos. No se emite.",
    loading: "Cargando borrador…",
    individual: "Particular",
    individualSub: "Persona física",
    company: "Empresa",
    companySub: "Persona jurídica",
    legalName: "Razón social *",
    fullName: "Nombre completo *",
    companyNamePlaceholder: "Nombre de la empresa",
    individualNamePlaceholder: "Nombre y apellidos",
    country: "País *",
    docCompany: "CIF / NIF de empresa",
    docIndividual: "DNI / NIE / Pasaporte",
    docCompanyPlaceholder: "CIF / NIF",
    docIndividualPlaceholder: "DNI, NIE (X1234567A) o pasaporte",
    email: "Email",
    emailOptional: "(opcional)",
    lodgingTitle: "Alojamiento",
    lodgingName: "Alojamiento",
    lodgingNoteBefore: "Se toma de la reserva",
    lodgingNoteAfter: ". Para cambiar este importe, edítalo en la reserva.",
    chargesTitle: "Cargos y servicios",
    chargesHelp: "Añade conceptos guardados sin alterar el alojamiento.",
    addCharge: "Agregar cargo o servicio",
    colConcept: "Concepto",
    colQty: "Cant.",
    colUnitPrice: "P. unit.",
    colTotal: "Total",
    linesEmpty: "Sin conceptos adicionales.",
    linesEmptyReserva: "La factura incluye solo el alojamiento.",
    total: "Total",
    cancel: "Cancelar",
    saving: "Guardando…",
    saveChanges: "Guardar cambios",
  },
  void: {
    doneTitle: "Factura anulada",
    doneSubtitle: "Factura rectificativa emitida correctamente",
    whatHappened: "¿Qué pasó?",
    doneCreditNote: "Se emitió la factura rectificativa",
    doneListed: "La factura queda en el listado marcada como anulada",
    doneCharges: "Los cargos adicionales quedaron liberados",
    doneGuest: "El huésped puede volver a solicitar su factura",
    nextStepsLabel: "Próximos pasos:",
    nextStepsText: "Puedes agregar o corregir cargos en la reserva. Luego reenvía el link de facturación al huésped.",
    understood: "Entendido",
    title: "Anular y reemitir factura",
    introBefore: "Esta acción",
    introStrong: "anulará la factura emitida",
    introAfter: "mediante una factura rectificativa oficial.",
    willEmit: "Se emitirá una factura rectificativa",
    willList: "La factura seguirá en el listado marcada como anulada",
    willFree: "Los cargos adicionales quedarán liberados",
    willAllowGuest: "El huésped podrá volver a solicitar la factura",
    reasonLabel: "Motivo de la anulación",
    reasonOther: "Otro motivo…",
    reasonPlaceholder: "Explica por qué anulas esta factura",
    warning: "La factura rectificativa es un documento fiscal oficial. Úsala solo si de verdad necesitas corregir la factura.",
    cancel: "Cancelar",
    emitting: "Emitiendo factura rectificativa…",
    confirm: "Sí, anular y reemitir",
  },
  statusFilters: {
    all: "Todas",
    draft: "Borradores",
    sent: "Emitidas",
    processing: "Procesando",
    error: "Con error",
    pending: "Pendientes",
    voided: "Anuladas",
  },
  voidReasons: {
    wrongTaxData: "Datos fiscales del cliente incorrectos",
    wrongAmount: "Importe o cargos incorrectos",
    duplicate: "Factura duplicada",
    cancelledReservation: "Reserva cancelada",
    reissue: "Anulación para reemisión con datos o cargos corregidos",
  },
  statusLabels: {
    draft: "Borrador",
    sent: "Emitida",
    processing: "Procesando",
    error: "Error",
    pending: "Pendiente",
    corrected: "Corregida",
    voided: "Anulada",
  },
  client: {
    fallbackName: "Cliente",
    fiscalPending: "Perfil fiscal pendiente",
    fiscalSaved: "Perfil fiscal guardado",
  },
  reservation: {
    noCode: "Sin código",
    noDates: "Sin fechas",
    noHolder: "Sin titular",
    propertyFallback: "Alojamiento #{id}",
  },
  emisorFallback: "Emisor #{id}",
  toasts: {
    selectClientComplete: "Selecciona un cliente con perfil fiscal completo.",
    selectReservationOrCharge: "Selecciona una reserva o agrega al menos un cargo o servicio.",
    saveDraftError: "No se pudo guardar el borrador.",
    createError: "No se pudo crear la factura.",
    quoteSent: "Presupuesto enviado a {email}",
    quoteError: "No se pudo enviar el presupuesto.",
    previewError: "No se pudo generar la vista previa.",
    previewName: "Vista previa",
    emitRejected: "La plataforma fiscal rechazó la emisión.",
    emitError: "No se pudo emitir la factura. Revisa los datos fiscales e inténtalo de nuevo.",
    selectClientToContinue: "Selecciona un cliente con perfil fiscal para continuar.",
    loadDraftError: "No se pudieron cargar los datos del borrador.",
    nameRequired: "Indica el nombre del cliente.",
    countryRequired: "Selecciona el país del cliente.",
    selectCatalogCharge: "Selecciona al menos un cargo o servicio del catálogo.",
    retryError: "No se pudo reintentar.",
    saveError: "No se pudo guardar.",
    voidError: "No se pudo anular la factura.",
    deleteError: "No se pudo eliminar.",
  },
};
